export default {
  loading: true,
  widgets: {
    transactions: {
      value: null
    },
    weather: {
      value: null,
    },
    responsiveness: {
      value: null,
    },
    events: {
      value: null
    },
    hits: {
      value: null
    },
    convertion: {
      value: null
    },
    jsFrameworks: {
      range: null,
      values: null,
      labels: null
    },
    topWines: {
      range: null,
      values: null,
      labels: null
    },
    map3D: {
      // not needed in this tutorial
    }
  }
}
